import React, { useContext, useEffect, useRef, useState } from "react";
import styles from "./Main.module.scss";
import StatesContext from "../../context/states";
import Player from '../../components/Player/Player';

const Main = () => {
  const states = useContext(StatesContext);
  const { stage, hideMain, isMobile } = states;
  const refWrap = useRef(null);

  useEffect(() => {
    const wrap = refWrap.current;
    if (!hideMain) {
      wrap.classList.remove(styles.hide);
    } else {
      wrap.classList.add(styles.hide);
    }
  }, [hideMain, isMobile]);

  return (
    <>
      <div className={`${styles.wrap} ${styles.hide}`} ref={refWrap} key={isMobile}>
        <Player />
      </div>
    </>
  );

}

export default Main;
